export default "__VITE_ASSET__BQ3gsMhd__"